/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'profilency_statistics': {
    width: 17,
    height: 17,
    viewBox: '0 0 17 17',
    data: '<path pid="0" d="M6.159 11.577a.982.982 0 1 0-1.964 0 .982.982 0 0 0 1.964 0zm5.606-3.87a1.982 1.982 0 0 1-2.844 2.756l-1.79.784a1.982 1.982 0 1 1-.41-.912l1.667-.73a1.982 1.982 0 0 1 2.532-2.459l.726-1.644a1.982 1.982 0 1 1 .926.38l-.807 1.826zm-.5 1.317a.982.982 0 1 0-1.964 0 .982.982 0 0 0 1.964 0zm2.553-5.106a.982.982 0 1 0-1.964 0 .982.982 0 0 0 1.964 0zM.758.772h1v14.65c0 .128.104.232.232.232h14.65v1H1.99c-.68 0-1.232-.552-1.232-1.232V.772z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/profilency_statistics.js